import(/* webpackMode: "eager" */ "/home/ubuntu/download/696dbb6a1beda80014c07bc0/electromoto_factory/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download/696dbb6a1beda80014c07bc0/electromoto_factory/src/app/homepage/components/CertificationCarousel.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download/696dbb6a1beda80014c07bc0/electromoto_factory/src/app/homepage/components/Footer.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download/696dbb6a1beda80014c07bc0/electromoto_factory/src/app/homepage/components/GlobalPresence.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download/696dbb6a1beda80014c07bc0/electromoto_factory/src/app/homepage/components/HeroSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download/696dbb6a1beda80014c07bc0/electromoto_factory/src/components/common/Header.tsx");
;
import(/* webpackMode: "eager" */ "/home/ubuntu/download/696dbb6a1beda80014c07bc0/electromoto_factory/src/components/ui/AppIcon.tsx");
